module.exports = __webpack_public_path__ + "img/duplicate-icon.14bd0df4.svg";